module.exports = __webpack_public_path__ + "static/media/overlapsing_circles.7a812c10.svg";